// AutomationSystemType values, hand-synched w/ PortCall.Models\DomainSettings\AutomationSystem.cs
export enum AutomationSystemType {
    PortCallSystem            = 'SYS',
    SystemUpgrade             = 'UPG',
    TransasNaviHarbour        = 'TNH',
    WartsilaEnhancedEstimates = 'WES',
}



// WEBPACK FOOTER //
// ./data/models/AutomationSystemType.ts